module.exports = __webpack_public_path__ + "assets/0cbd4fe340b74ede5aa8d1783c8f3816.json";